import LegalPage from "@/components/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy." updated="Feb 2026" testId="privacy-page">
      <p>This policy explains what personal information Carpe Diem Goa collects when you use <a href="https://carpediemgoa.com">carpediemgoa.com</a>, how we use it, and the choices you have.</p>

      <h2>1. What we collect</h2>
      <ul>
        <li><strong>Booking details</strong> — name, email, phone number and payment reference — when you register for an event.</li>
        <li><strong>Messages</strong> — anything you send via our contact form or by email.</li>
        <li><strong>Application details</strong> — CV, artwork images, statements — when you apply to exhibit in our gallery.</li>
        <li><strong>Basic technical data</strong> — device type, browser, and pages visited — for usual analytics.</li>
      </ul>

      <h2>2. Why we collect it</h2>
      <ul>
        <li>To process your booking, confirm attendance and issue receipts.</li>
        <li>To reply to messages and applications.</li>
        <li>To improve our programme and communicate about upcoming events if you have opted in.</li>
      </ul>

      <h2>3. Payment data</h2>
      <p>Payments are processed by <a href="https://razorpay.com" target="_blank" rel="noreferrer">Razorpay</a>. We never see, store or handle your full card / UPI credentials — Razorpay handles them under its own security certifications (PCI-DSS Level 1).</p>

      <h2>4. Emails</h2>
      <p>Transactional emails (booking confirmations, application updates) are sent via <a href="https://resend.com" target="_blank" rel="noreferrer">Resend</a>. We do not send marketing emails without your explicit opt-in.</p>

      <h2>5. Storage & retention</h2>
      <p>Personal data is stored on secure cloud infrastructure (MongoDB Atlas, hosted in a region with appropriate data protection). We retain booking records for up to 3 years for accounting purposes, and remove other data on request.</p>

      <h2>6. Sharing</h2>
      <p>We do not sell your data. We share information only with our payment processor (Razorpay), our email delivery provider (Resend), and, where legally required, with Indian tax and regulatory authorities.</p>

      <h2>7. Your rights</h2>
      <p>You may request a copy of the data we hold about you, ask us to correct it, or ask us to delete it by writing to <a href="mailto:info@carpediemgoa.com">info@carpediemgoa.com</a>. We will respond within 30 days.</p>

      <h2>8. Cookies</h2>
      <p>Our site uses only essential cookies required to keep you signed into your admin session and to remember your preferences. We do not use tracking or advertising cookies.</p>

      <h2>9. Changes</h2>
      <p>Any updates to this policy will appear on this page with a revised "Last updated" date.</p>
    </LegalPage>
  );
}
